// extracted by mini-css-extract-plugin
export default {"fullBannerContainer":"FullBanner_fullBannerContainer__zTJxF","fullBannerImg":"FullBanner_fullBannerImg__3W6sJ","fullBannerInfo":"FullBanner_fullBannerInfo__gv43n"};